import { render, staticRenderFns } from "./EditHint.vue?vue&type=template&id=f5fa5f5c"
import script from "./EditHint.vue?vue&type=script&lang=js"
export * from "./EditHint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports